import { days } from "./days.js";
import { HoursOfOperation } from "./HoursOfOperation.js";
import { Stack } from "@mantine/core";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/hours-of-operation/HoursByDay.tsx
const HoursByDay = ({ hours, showIcon, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	const dayNames = {
		sunday: t("hoursOfOperation.sunday"),
		monday: t("hoursOfOperation.monday"),
		tuesday: t("hoursOfOperation.tuesday"),
		wednesday: t("hoursOfOperation.wednesday"),
		thursday: t("hoursOfOperation.thursday"),
		friday: t("hoursOfOperation.friday"),
		saturday: t("hoursOfOperation.saturday")
	};
	return /* @__PURE__ */ jsx(Stack, {
		"data-testid": testId,
		children: days.map((day) => /* @__PURE__ */ jsx(HoursOfOperation, {
			actionable: false,
			day: dayNames[day] ?? day,
			times: hours[day],
			showIcon
		}, `hours-of-operation-${day}`))
	});
};

//#endregion
export { HoursByDay };